import PropTypes from 'prop-types';
import React from 'react';

const CloseIcon = ({ style, className } = {}) =>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 298.7 298.5"
    enableBackground="new 0 0 298.7 298.5"
    preserveAspectRatio="xMidYMid"
    style={style}
    className={className}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M185.3,149.3L295.6,39c3.9-3.8,3.9-10.2,0-14.1L273.6,2.9
    	c-3.8-3.9-10.2-3.9-14.1,0L149.2,113.2L38.9,2.9C35.1-1,28.7-1,24.8,2.9L2.9,24.8C-1,28.7-1,35.1,2.8,39l110.3,110.3L2.9,259.5
    	c-3.9,3.8-3.9,10.2,0,14.1l21.8,21.9c3.9,3.9,10.3,3.9,14.2,0l110.2-110.2l110.2,110.2c3.8,3.9,10.2,3.9,14.1,0l21.9-21.9
    	c3.9-3.8,3.9-10.2,0-14.1L185.3,149.3z"
    />
  </svg>;

CloseIcon.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
};

CloseIcon.defaultProps = {
  style: null,
  className: '',
};

export default CloseIcon;



// WEBPACK FOOTER //
// ./src/components/Common/CloseIcon.js